<template>
  <CockpitDialog title="巡检异常" @close="$emit('close')" class="left-420px top-180px">
    <div>
      <tableButtonGroup
        class="ml-10px"
        v-model="tabActive"
        :list="tabSystemList"
        @btn-click="tabChangeOrSearch"
      />
    </div>
    <!-- 点巡检异常记录 -->
    <div
      class="mt-10px h-[calc(100%-60px)]"
      v-if="tabActive === tabSystemList[0]"
      v-loading="loading"
    >
      <el-table :data="tableData" height="100%">
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
        <!-- <el-table-column label="设备名称" prop="deviceName" align="center"></el-table-column>
        <el-table-column label="设备编码" prop="deviceCode" align="center"></el-table-column> -->
        <el-table-column
          label="报警内容"
          prop="alarmName"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="报警时间" prop="alarmTime" align="center"></el-table-column>
      </el-table>
    </div>
    <!-- 机器人告警记录 -->
    <div
      class="mt-10px h-[calc(100%-60px)]"
      v-if="tabActive === tabSystemList[1]"
      v-loading="loading"
    >
      <div class="flex mb-10px mr-10px">
        <span class="flex items-center text-[#fff]">开始时间：</span>
        <el-date-picker
          class="mr-10px w-300px"
          type="date"
          placeholder="选择开始日期"
          value-format="yyyy-MM-dd"
          v-model="searchForm.startTime"
          clearable
        ></el-date-picker>
        <span class="flex items-center text-[#fff]">结束时间：</span>
        <el-date-picker
          class="mr-10px w-300px"
          type="date"
          placeholder="选择结束日期"
          value-format="yyyy-MM-dd"
          v-model="searchForm.endTime"
          clearable
        ></el-date-picker>
        <el-button size="small" type="primary" @click="tabChangeOrSearch(tabActive)"
          >搜索</el-button
        >
      </div>
      <div class="mt-10px h-[calc(100%-50px)]">
        <el-table :data="tableData" height="100%">
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column label="机器人名称" prop="robotName" align="center"></el-table-column>
          <el-table-column
            label="告警内容"
            prop="alarmContent"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="告警等级" prop="alarmLevel" align="center">
            <template slot-scope="scope">
              {{ alarmLevelMap[scope.row.alarmLevel] }}
            </template>
          </el-table-column>
          <el-table-column label="告警开始时间" prop="startTime" align="center"></el-table-column>
          <el-table-column label="告警结束时间" prop="endTime" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <!-- <el-button
                size="mini"
                :disabled="scope.row.alarmType !== 3"
                type="primary"
                @click="showViewDetail(scope.row)"
                >详情</el-button
              > -->
              <!-- <span
                class="text-blue-500 bold hover:text-blue-200 cursor-pointer"
                :class="{
                  '!text-gray-400 !hover:text-gray-400 !cursor-not-allowed':
                    scope.row.alarmType !== 3,
                }"
                @click="showViewDetail(scope.row)"
                >详情</span
              > -->
              <span
                class="text-blue-500 bold hover:text-blue-200 cursor-pointer"
                @click="showViewDetail(scope.row)"
                >详情</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 视频识别异常记录 -->
    <div
      class="mt-10px h-[calc(100%-60px)]"
      v-if="tabActive === tabSystemList[2]"
      v-loading="loading"
    >
      <div class="flex mb-10px mr-10px">
        <el-input
          class="mr-10px w-200px"
          v-model="searchForm.keyword"
          placeholder="请输入关键字"
          clearable
        ></el-input>
        <el-select
          class="mr-10px w-200px"
          v-model="searchForm.alarmType"
          placeholder="报警类型"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in alarmTypeList"
            :key="index"
            :value="item"
            :label="item"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px w-400px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchForm.timeRange"
          clearable
        ></el-date-picker>
        <el-button size="small" type="primary" @click="tabChangeOrSearch(tabActive)"
          >搜索</el-button
        >
      </div>
      <div class="mt-10px h-[calc(100%-50px)]">
        <el-table :data="tableData" height="100%">
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column label="设备名称" prop="cameraName" align="center"></el-table-column>
          <el-table-column label="报警类型" prop="alarmType" align="center"></el-table-column>
          <el-table-column label="识别图片" prop="alarmPicture" align="center">
            <template slot-scope="scope">
              <el-image
                class="w-30px h-30px"
                :src="scope.row.alarmPicture"
                :preview-src-list="[scope.row.alarmPicture]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="识别时间" prop="alarmTime" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 公共分页 -->
    <div class="text-center">
      <el-pagination
        @current-change="handlePageChange"
        :current-page="currentPage"
        background
        :page-sizes="[100, 200, 300, 400]"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 查看详情弹窗 -->
    <DialogViewDetail
      class="w-1000px h-475px"
      :detailData="detailData"
      v-if="showDialogViewDetail"
      @close="showDialogViewDetail = false"
    ></DialogViewDetail>
  </CockpitDialog>
</template>

<script>
import { WisdomPowerApi, RobotViewAlarmApi, VideoAnlalysisAlarmApi } from '@wiz-api/huizhou2'
import { SecurityAlarmRecordApi } from '@wiz-api/security-management'
import { DeviceAlarmApi } from '@wiz-api/large-screen-management'
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import tableButtonGroup from '@/components/cockpit/TableButtonGroup'
import dayjs from 'dayjs'
import DialogViewDetail from './DialogViewDetail'

const wisdomPowerApi = new WisdomPowerApi()
const robotViewAlarmApi = new RobotViewAlarmApi()
const securityAlarmRecordApi = new SecurityAlarmRecordApi()
const deviceAlarmApi = new DeviceAlarmApi()
const videoAnlalysisAlarmApi = new VideoAnlalysisAlarmApi()
export default {
  name: 'dialogError',
  components: { CockpitDialog, DialogViewDetail, tableButtonGroup },
  props: {
    tabType: {
      type: Number,
      default: 0,
    },
    errorData: {
      type: Object,
      default: () => { return {} },
    }
  },
  data() {
    return {
      loading: false,
      detailData: {},
      showDialogViewDetail: false,
      tabSystemList: ['点巡检异常记录', '机器人告警记录', '视频识别异常记录'],
      tabActive: '点巡检异常记录',
      searchForm: {
        startTime: '',
        endTime: '',
        keyword: '',
        alarmType: '',
        timeRange: [],
      },
      pageSize: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      alarmLevelMap: {
        0: '正常',
        1: '预警',
        2: '一般告警',
        3: '严重告警',
        4: '危急告警',
      },
      alarmTypeList: [],
    }
  },
  watch: {},
  created() {
    this.tabActive = this.tabSystemList[this.tabType]
    this.getVideoAnomalTypeList()
    // if (this.tabActive === this.tabSystemList[2]) {
    //   this.getOneVideoAnomal()
    //   return
    // }
    this.repuestType(this.tabActive)
  },
  mounted() {},
  methods: {
    // 请求类型
    repuestType(val) {
      switch (val) {
        case this.tabSystemList[0]:
          this.getRobotAndPatrolAnomalList()
          break
        case this.tabSystemList[1]:
          this.getRobotViewPageList()
          break
        case this.tabSystemList[2]:
          this.getVideoAnomalList()
          break
        default:
          break
      }
    },
    // 切换tab 或者 搜索
    tabChangeOrSearch(val) {
      this.currentPage = 1
      this.total = 0
      this.repuestType(val)
    },
    handlePageChange(newPage) {
      this.currentPage = newPage
      this.repuestType(this.tabActive)
    },
    // 详情按钮
    showViewDetail(row) {
      this.detailData = { ...row, alarmLevel: this.alarmLevelMap[row.alarmLevel] }
      this.showDialogViewDetail = true
    },
    // 根据类型获取点巡检异常记录和机器人巡检异常记录
    async getRobotAndPatrolAnomalList() {
      this.loading = true
      this.tableData = []
      try {
        const skipCount = (this.currentPage - 1) * this.pageSize
        const [err, res] = await deviceAlarmApi.getPagedDeviceAlarms({
          type: 0,
          skipCount,
          maxResultCount: this.pageSize,
        })
        if (err) {
          throw new Error('获取异常记录失败')
        }
        this.total = res.totalCount
        this.tableData = res.items
      } catch (error) {
        console.error(error.message)
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    // 获取机器人告警信息列表
    async getRobotViewPageList() {
      this.loading = true
      this.tableData = []
      try {
        const { startTime, endTime } = this.searchForm
        const skipCount = (this.currentPage - 1) * this.pageSize
        const [err, res] = await robotViewAlarmApi.getRobotViewPageList({
          startTime,
          endTime,
          skipCount,
          maxResultCount: this.pageSize,
        })

        if (err) {
          throw new Error('获取告警信息失败')
        }

        this.total = res.totalCount
        this.tableData = res.items.map((item) => {
          return {
            ...item,
            startTime: dayjs(item.startTime).format('YYYY-MM-DD HH:mm:ss'),
            endTime: dayjs(item.endTime).format('YYYY-MM-DD HH:mm:ss'),
            createTime: dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
          }
        })
      } catch (error) {
        console.error(error.message)
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    // 获取视频识别异常类型列表
    async getVideoAnomalTypeList() {
      const [err, res] = await securityAlarmRecordApi.getAlarmTypeNames()
      if (err) {
        return
      }
      this.alarmTypeList = res
    },
    // 获取具体单个视频识别异常
    async getOneVideoAnomal() {
      this.loading = true
      this.tableData = []
      try {
        const [err, res] = await securityAlarmRecordApi.getAlarmDetail(
          {
            id: this.errorData.alarmId,
          }
        )
        if (err) {
          throw new Error('获取异常记录失败')
        }
        this.total = 1
        this.tableData.push({
          ...res,
          identifyTime: dayjs(res.identifyTime).format('YYYY-MM-DD HH:mm:ss'),
        })
      } catch (error) {
        console.error(error.message)
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    // 获取视频识别异常记录
    async getVideoAnomalList() {
      this.loading = true
      this.tableData = []
      try {
        const { keyword, alarmType, timeRange } = this.searchForm
        const [err, res] = await videoAnlalysisAlarmApi.getVideoAlarms({
          keyword,
          alarmType,
          startTime: timeRange && timeRange.length > 0 ? timeRange[0] : '',
          endTime: timeRange && timeRange.length > 1 ? timeRange[1] : '',
          skipCount: (this.currentPage - 1) * this.pageSize,
          maxResultCount: this.pageSize,
        })
        if (err) {
          throw new Error('获取异常记录失败')
        }
        this.total = res.totalCount
        this.tableData = res.items.map(({ identifyTime, ...item }) => {
          return {
            ...item,
            identifyTime: dayjs(identifyTime).format('YYYY-MM-DD HH:mm:ss'),
          }
        })
      } catch (error) {
        console.error(error.message)
        this.total = 0
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
